module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-384x384-318813bb4b3a568e8f7741752addacb4.png";